<div class="me-payment">
    <div class="me-payment__body">
        <div class="klenico-me__background">
            <div class="klenico-me__background__inner"></div>
        </div>

        <div class="container me-payment__body__content">
            <me-payment-coupon-card></me-payment-coupon-card>
            <me-payment-form></me-payment-form>
        </div>
    </div>
</div>